<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="titlePage" id="tp01">
<h2 class="titlePageTitle"><span class="bold">The Covenant Rising</span></h2>
<p class="titlePageSubtitle"><span class="smallCaps">BOOK ONE</span></p>
<p class="titlePageSubtitle1"><span class="smallCaps">OF THE</span></p>
<p class="titlePageSubtitle1"><span class="smallCaps">DREAMTIME</span></p>
<br/>
<h2 class="titlePageAuthor"><span class="bold">STAN NICHOLLS</span></h2>
<p class="image"><img alt="img" src="logo.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// thecovenantrising.vue?17ec1d44